import { motion } from "framer-motion";
import { useCallback, useRef } from "react";
import useMotionPreferences from "@/hooks/useMotionPreferences";
import { EASING, DURATION } from "@/lib/motionSystem";

export default function GlassCard({ children, className = "", hover = true, tilt = false, delay = 0, ...props }) {
    const cardRef = useRef(null);
    const { allowDecorativeEffects } = useMotionPreferences();

    const handleMouseMove = useCallback((e) => {
        if (!tilt || !allowDecorativeEffects || !cardRef.current) return;
        const rect = cardRef.current.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        cardRef.current.style.transform = `perspective(800px) rotateX(${-y * 5}deg) rotateY(${x * 5}deg) translateY(-3px)`;
    }, [allowDecorativeEffects, tilt]);

    const handleMouseLeave = useCallback(() => {
        if (!tilt || !cardRef.current) return;
        cardRef.current.style.transform = "";
    }, [tilt]);

    return (
        <motion.div
            ref={cardRef}
            className={`
                premium-surface rounded-2xl
                [backdrop-filter:blur(20px)_saturate(180%)]
                [-webkit-backdrop-filter:blur(20px)_saturate(180%)]
                will-change-transform
                ${hover ? "hover:-translate-y-[2px] hover:border-[rgba(129,140,248,0.45)] hover:shadow-[0_0_26px_rgba(99,102,241,0.22),0_8px_32px_rgba(0,0,0,0.4)]" : ""}
                transition-all duration-200 ease-out
                ${className}
            `}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: DURATION.sectionReveal, delay, ease: EASING.smooth }}
            {...props}
        >
            {children}
        </motion.div>
    );
}
